import {
  Spacing
} from 'UI'

export default {
  paperClass: {
    display: 'flex',
    margin: () => Spacing(0, 0, 5, 0),
    padding: '24px 24px 36px 24px',
    justifyContent: 'space-between',
    width: '100%'
  },
  ratingClass: {
    flexDirection: 'column',
    flex: 1
  },
  ratingDetailsClass: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  ratingContainerClass: {
    display: 'flex'
  },
  paperRatingDetailsClass: {
    height: '100%',
    display: 'flex',
    margin: () => Spacing(0, 0, 5, 0),
    padding: '24px 24px 36px 24px',
    justifyContent: 'space-between',
    width: '100%'
  }
}
